import { API, authClient } from "../index";

// Get tasa by id
export const getTasaById = (id) => {
  return authClient().get(`${API}/tasa/${id}`);
};
export const getTasas = () => {
  return authClient().get(`${API}/tasa`);
};

// Create tasa
export const postTasa = async (tasa) => {
  return authClient().post(`${API}/tasa`, tasa);
};

// Update tasa
export const updateTasa = async (id, tasa) => {
  return authClient().put(`${API}/tasa/${id}`, tasa);
};
